import { useIsAuthenticated } from "@azure/msal-react";
import { Loader } from "@components/Loader";
import { ROUTER_PATHS } from "@constants/index";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";

export const Login = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTER_PATHS.main);
    }
  }, [isAuthenticated]);

  // Login redirect is handled by App.tsx auth guard
  return (
    <div className={styles.loginContainer}>
      <Loader className="content" show={true} />
      <div className={styles.loginWrapper}>
        <h1>Signing in...</h1>
        <p>Redirecting to Microsoft login</p>
      </div>
    </div>
  );
};
